<template>
  <div class="recharge-history-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="header-left">
        <h2 class="page-title">充值账单</h2>
        <p class="page-subtitle">查看您的充值历史和订单状态</p>
      </div>
      <div class="header-right">
        <el-input 
          v-model="searchOrderNo" 
          placeholder="请输入订单编号" 
          suffix-icon="el-icon-search"
          clearable
          style="width: 200px; margin-right: 10px;"
        ></el-input>
        <el-select 
          v-model="searchPaymentType" 
          placeholder="支付方式" 
          clearable
          style="width: 130px; margin-right: 10px;"
        >
          <el-option label="微信" value="微信"></el-option>
          <el-option label="支付宝" value="支付宝"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>
    </div>

    <!-- 订单列表 -->
    <div class="order-table-wrapper">
      <el-table 
        :data="orderList" 
        border 
        style="width: 100%"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        
        <el-table-column prop="orderNo" label="订单编号" width="250" show-overflow-tooltip></el-table-column>
        
        <el-table-column prop="title" label="商品名称" width="100"></el-table-column>
        
        <el-table-column prop="totalFee" label="订单金额"  align="center">
          <template slot-scope="scope">
            <span class="amount">¥{{ (scope.row.totalFee / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="points" label="充值积分" width="100" align="center">
          <template slot-scope="scope">
            <span class="points">{{ scope.row.points || 0 }}</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="paymentType" label="支付方式" width="120" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.paymentType === '微信'" style="background-color: #07C160; color: white; border: none;" size="small">
              <i class="el-icon-chat-dot-square"></i> 微信
            </el-tag>
            <el-tag v-else-if="scope.row.paymentType === '支付宝'" style="background-color: #1677FF; color: white; border: none;" size="small">
              <i class="el-icon-coin"></i> 支付宝
            </el-tag>
            <el-tag v-else type="info" size="small">{{ scope.row.paymentType }}</el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="orderStatus" label="订单状态" width="130" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.orderStatus === '未支付'" type="danger" size="small">
              {{ scope.row.orderStatus }}
            </el-tag>
            <el-tag v-else-if="scope.row.orderStatus === '支付成功'" type="success" size="small">
              {{ scope.row.orderStatus }}
            </el-tag>
            <el-tag v-else-if="scope.row.orderStatus === '超时已关闭'" type="info" size="small">
              {{ scope.row.orderStatus }}
            </el-tag>
            <el-tag v-else-if="scope.row.orderStatus === '用户已取消'" type="warning" size="small">
              {{ scope.row.orderStatus }}
            </el-tag>
            <el-tag v-else type="info" size="small">
              {{ scope.row.orderStatus }}
            </el-tag>
          </template>
        </el-table-column>
        
        <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
        
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button 
              v-if="scope.row.orderStatus === '未支付'" 
              type="warning"
              size="small"
              @click="handleCancel(scope.row)"
            >
              取消
            </el-button>
            <el-button 
              type="danger" 
              size="small"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RechargeHistory',
  data() {
    return {
      loading: false,
      orderList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 搜索条件
      searchOrderNo: '',
      searchPaymentType: ''
    }
  },
  created() {
    this.loadOrderList()
  },
  methods: {
    // 加载订单列表
    async loadOrderList() {
      this.loading = true
      try {
        const user = JSON.parse(localStorage.getItem('user'))
        if (!user || !user.username) {
          this.$message.warning('请先登录')
          this.$router.push('/helper')
          return
        }

        const res = await this.request.get('/orderInfo/front/page', {
          params: {
            username: user.username,
            orderNo: this.searchOrderNo,
            paymentType: this.searchPaymentType,
            pageNum: this.currentPage,
            pageSize: this.pageSize
          }
        })

        if (res.code === '200' && res.data) {
          this.orderList = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.msg || '获取订单列表失败')
        }
      } catch (error) {
        console.error('加载订单列表失败:', error)
        this.$message.error('加载订单列表失败，请重试')
      } finally {
        this.loading = false
      }
    },

    // 取消订单
    async handleCancel(order) {
      try {
        const confirm = await this.$confirm('确定要取消订单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(() => false)

        if (!confirm) return

        this.loading = true
        
        let res
        if (order.paymentType === '微信') {
          res = await this.request.post(`/wx-pay/cancel/${order.orderNo}`)
        } else if (order.paymentType === '支付宝') {
          res = await this.request.post(`/ali-pay/trade/close/${order.orderNo}`)
        }

        if (res && res.code === '200') {
          this.$message.success('订单已取消')
          this.loadOrderList()
        } else {
          this.$message.error(res.msg || '取消订单失败')
        }
      } catch (error) {
        console.error('取消订单失败:', error)
        this.$message.error('取消订单失败，请重试')
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.loadOrderList()
    },

    // 重置
    handleReset() {
      this.searchOrderNo = ''
      this.searchPaymentType = ''
      this.currentPage = 1
      this.loadOrderList()
    },

    // 删除订单
    async handleDelete(order) {
      try {
        const confirm = await this.$confirm('确定要删除该订单吗？删除后无法恢复！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(() => false)

        if (!confirm) return

        this.loading = true
        
        const res = await this.request.delete(`/orderInfo/${order.id}`)

        if (res && res.code === '200') {
          this.$message.success('订单已删除')
          this.loadOrderList()
        } else {
          this.$message.error(res.msg || '删除订单失败')
        }
      } catch (error) {
        console.error('删除订单失败:', error)
        this.$message.error('删除订单失败，请重试')
      } finally {
        this.loading = false
      }
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadOrderList()
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.loadOrderList()
    }
  }
}
</script>

<style scoped>
.recharge-history-page {
  background: #f5f7fa;
  padding: 12px;
  height: calc(100vh - 118px);
}

/* 页面标题 */
.page-header {
  background: #fff;
  padding: 24px 32px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  flex-shrink: 0;
}

.header-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

/* 表格容器 */
.order-table-wrapper {
  background: #fff;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.amount {
  color: #f56c6c;
  font-weight: 600;
  font-size: 15px;
}

.points {
  color: #4f46e5;
  font-weight: 600;
  font-size: 15px;
}

.pagination-wrapper {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

/* 表格样式优化 */
::v-deep .el-table {
  font-size: 14px;
}

::v-deep .el-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

::v-deep .el-table td {
  padding: 12px 0;
}

::v-deep .el-tag {
  font-size: 12px;
}

::v-deep .el-button--text {
  padding: 0;
  color: #6366f1;
}

::v-deep .el-button--text:hover {
  color: #4f46e5;
}
</style>
